import { z } from 'zod';

export const verifyUserAttributePostRequestSchema = z.object({ attribute_name: z.string(), code: z.string() });
